/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { analyze } from '../../../../../../helpers';
import { getOrderSummary } from '../../../../../../queries';
import { addPromoCode } from '../../../../../../graphql/mutation';
import AddCodeButton from './AddCodeButton';
import s from './AddCodeButton.module.scss';

export const updateOrderSummaryQuery = (
  store,
  { data: { addPromoCode: addPromoCodeData } },
) => {
  if (addPromoCodeData) {
    store.writeQuery({
      query: getOrderSummary,
      data: { orderSummary: addPromoCodeData },
    });
  }
};

function AddCodeButtonVM({
  promoCodeAdded,
  crmCode,
  onSuccess,
  onError,
  ...props
}) {
  const iconName = promoCodeAdded ? 'check' : 'plus';
  const iconClassname = promoCodeAdded ? s.iconCheck : s.iconPlus;
  const label = promoCodeAdded ? 'ADDED' : 'ADD CODE';

  const [onAddPromoCode] = useMutation(addPromoCode, {
    update: updateOrderSummaryQuery,
  });
  const handleSubmit = () => {
    analyze({
      name: 'MemberWalletAddCode',
    });
    onAddPromoCode({
      variables: {
        code: crmCode,
      },
    })
      .then((response) => onSuccess && onSuccess(response.data))
      .catch((error) => onError && onError(error));
  };

  const mapProps = {
    ...props,
    iconName,
    iconClassname,
    label,
    handleSubmit,
    promoCodeAdded,
  };
  return <AddCodeButton data-testid="AddCodeButton" {...mapProps} />;
}

AddCodeButtonVM.propTypes = {
  promoCodeAdded: PropTypes.bool,
  crmCode: PropTypes.string.isRequired,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
};

export default AddCodeButtonVM;
